module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"229.5°-arc-x-4\"-in-pomona-california-26a51e1d723ba87064759de3f7bd52d4.png";